<template>
  <main>
    <ConfirmApp />
  </main>
</template>

<script>
import ConfirmApp from '../components/ConfirmApp'

export default {
  components: {
    ConfirmApp
  }
}
</script>
